import { getLocales } from 'assets/locales/Locale';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';

type Props = {
  claimJob: Model.IClaimJob;
  comments?: Model.IClaimJobComment[];
};

export default function ClaimJobPaymentItemInfoJobDetails({ claimJob }: Props) {
  const { lang } = getLocales();

  return (
    <>
      <h3>{lang.jobDetails}</h3>
      <div>
        {lang.claimNumber}: <b>{claimJob.claim?.number}</b>
      </div>
      <div>
        {lang.authorizationNumber}: <b>{claimJob.authorizationNumber ?? 'N/A'}</b>
      </div>
      <div>
        {lang.explanation}:{' '}
        <b>{claimJob.claimJobComments?.length > 0 ? claimJob.claimJobComments[0].comment : 'N/A'}</b>
      </div>
      <div>
        {lang.customerComplaint}: <b>{claimJob.customerComplaint}</b>
      </div>
      <div>
        {lang.causeOfFailure}: <b>{claimJob.cause}</b>
      </div>
      <div>
        {lang.correctionDetails}: <b>{claimJob.correction}</b>
      </div>
      <div>
        {lang.claimType}: <b>{claimJob.claimType?.name ?? 'N/A'}</b>
      </div>
      <div>
        {lang.decidedDate}:{' '}
        <b>{claimJob.decidedDateUtc ? localizeDate(claimJob.decidedDateUtc, defaultDateTimeFormat) : 'N/A'}</b>
      </div>
    </>
  );
}
